/**
 * Get URL param value (ex: `value` from `?param=${value}`)
 * @param {String} param
 * @return {String}
 */
const getParam = param => {
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  return urlParams.get(param)
}

/**
 * Insert URL param value
 * @param {String} key
 * @param {String} value
 */
const insertParam = (key, value) => {
  const url = new URL(window.location.href)
  const params = new URLSearchParams(url.search)
  params.set(key, value)
  window.history.replaceState({}, '', decodeURIComponent(`${window.location.pathname}?${params}${window.location.hash}`))
}

export { getParam, insertParam }



// WEBPACK FOOTER //
// ./src/helpers/URL.js